/**
 * 工作台展示用：格式化与轻量计算（与后端 utils/dashboardCalculate 口径一致说明见接口文档）
 */

export function toInteger(n) {
  const x = Math.round(Number(n) || 0)
  return Number.isFinite(x) ? x : 0
}

/** 数量类：整数展示 */
export function formatCount(n) {
  return String(toInteger(n))
}

/** 营业额：两位小数 + 千分位（不带 ¥，由模板加） */
export function formatCurrencyYuan(n) {
  const x = Number(n)
  const v = Number.isFinite(x) ? x : 0
  return v.toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

/** 百分比保留一位小数 */
export function formatPercent1(n) {
  const x = Number(n)
  if (!Number.isFinite(x)) return '0.0'
  return (Math.round(x * 10) / 10).toFixed(1)
}

/** 环比展示：带符号与 % */
export function formatMoMPercent(n) {
  const x = Number(n)
  if (!Number.isFinite(x)) return '—'
  const s = x > 0 ? '+' : ''
  return `${s}${formatPercent1(x)}%`
}

/** 客单价 */
export function averageOrderValue(revenue, paidCount) {
  const p = toInteger(paidCount)
  if (p < 1) return 0
  return (Number(revenue) || 0) / p
}
